import programs from "./programs";

export const employer = {
    programs,
};

export default employer;
